import locales from "./locales/locales";
import router from './routes/routes'

export const RightsModule = {
    name: 'rights',
    routes: router,
    locales: locales,
}